import React from 'react';
import type { NotesProps } from './types';
import NotesContent from './ui/components/NotesContent';
import { NotesProvider } from './ui/components/NotesProvider';

export default function Notes(props: NotesProps) {
    return (
        <NotesProvider entity={props.entity} disableTranslation={props.disableTranslation}>
            <NotesContent {...props} />
        </NotesProvider>
    );
}
